/**
 * Reusable toast notification component.
 *
 * Renders a MUI Snackbar with Alert for consistent
 * toast notifications across the app. Positioned at
 * bottom-center for mobile-friendly visibility.
 */

import { Alert, Snackbar } from '@mui/material';
import React from 'react';

import type { ToastSeverity } from '../hooks/useToast';

interface ToastProps {
  open: boolean;
  message: string;
  severity: ToastSeverity;
  onClose: () => void;
  autoHideDuration?: number;
}

const Toast: React.FC<ToastProps> = ({
  open,
  message,
  severity,
  onClose,
  autoHideDuration = 4000,
}) => (
  <Snackbar
    open={open}
    autoHideDuration={autoHideDuration}
    onClose={onClose}
    anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    sx={{ mb: 8 }}
  >
    <Alert
      onClose={onClose}
      severity={severity}
      variant="filled"
      sx={{ width: '100%', maxWidth: 400 }}
    >
      {message}
    </Alert>
  </Snackbar>
);

export default Toast;
